import { Loader2, FlaskConical } from "lucide-react";

export const LoadingState = () => {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-muted-foreground gap-4">
      <Loader2 className="h-8 w-8 animate-spin" />
      <p className="text-sm font-medium">Loading test results...</p>
    </div>
  );
};

export const EmptyState = () => {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-muted-foreground">
      <div className="w-16 h-16 rounded-lg bg-muted flex items-center justify-center mb-4">
        <FlaskConical className="h-8 w-8 text-muted-foreground" />
      </div>
      <p className="text-base font-medium text-foreground mb-1">
        No Test Selected
      </p>
      <p className="text-sm text-muted-foreground">
        Select a test from history or start a new one
      </p>
    </div>
  );
};
